/**
 * FAIM2 AG Grid theme — Quartz base with brand colors.
 *
 * Usage: import { faim2Theme, faim2ThemeDark } from '@/components/data-grid/theme'
 * Then pass as `theme` prop on AgGridReact or DataGrid.
 */
import { themeQuartz, colorSchemeDark } from 'ag-grid-community';

export const faim2Theme = themeQuartz.withParams({
  accentColor: '#009639',        // HC green
  borderRadius: 4,
  headerFontWeight: 600,
  rowHoverColor: '#f0faf4',      // light green tint on hover
  spacing: 6,
  wrapperBorderRadius: 8,
});

export const faim2ThemeDark = themeQuartz.withPart(colorSchemeDark).withParams({
  accentColor: '#4dc484',
  borderRadius: 4,
  headerFontWeight: 600,
  spacing: 6,
  wrapperBorderRadius: 8,
});
